<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    class="cancel-icon"
  >
    <path
      d="M12 2a10 10 0 100 20 10 10 0 000-20zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
    />
  </svg>
</template>

<script>
export default {
  name: 'CancelIcon',
}
</script>

<style scoped>
.cancel-icon {
  width: 24px;
  height: 24px;
}
</style>
